import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getReviews, getReviewsStats } from '../../selectors/developerV2';

import { ReviewItem } from '../../components/ReviewsDetails/parts/ReviewItem';
import { ReviewAuthor } from '../../components/ReviewCommon/ReviewAuthor';
import { ReviewComment } from '../../components/ReviewsDetails/parts/ReviewComment';

import { ReviewsReactionsContainer } from '../ReviewsReactionsContainer';
import { MobileRating } from '@cian/frontend-reviews-components';
import { Link } from '../../components/Link';
import { IReview } from '../../types/developerV2/review';
import { ReviewsDetails } from '../../components/ReviewsDetails/ReviewsDetails';
import { useEffect } from 'react';
import { getIsReviewDetailsOpen } from '../../selectors/reviewDetails/reviewDetailsOpen';
import { getReviewDetailsReviewId } from '../../selectors/reviewDetails/reviewDetailsReviewId';
import { setReviewDetailsCloseAction } from '../../actions/reviewsDetails/actions';

const fullReviewIdPattern = (id: string) => `full_review_${id}`;

export const ReviewsDetailsContainer = () => {
  const dispatch = useDispatch();
  const open = useSelector(getIsReviewDetailsOpen);
  const selectedReview = useSelector(getReviewDetailsReviewId);
  const reviews = useSelector(getReviews);
  const reviewStat = useSelector(getReviewsStats);

  const onClose = React.useCallback(() => {
    dispatch(setReviewDetailsCloseAction());
  }, [dispatch, setReviewDetailsCloseAction]);

  useEffect(() => {
    if (selectedReview) {
      const element = document.getElementById(fullReviewIdPattern(selectedReview));
      element?.scrollIntoView();
    }
  }, [selectedReview, open]);

  if (!reviews || reviews.length === 0) {
    return null;
  }

  return (
    <ModalWindow open={open} onClose={onClose} width={880} maxWidth={880} fixed={true} title="Популярные отзывы">
      <ReviewsDetails>
        <MobileRating value={reviewStat.totalRate} />
        <div>
          {reviews.map((review: IReview) => (
            <ReviewItem
              key={fullReviewIdPattern(review.id)}
              id={fullReviewIdPattern(review.id)}
              author={
                <ReviewAuthor
                  newbuildingName={review.newbuildingName}
                  newbuildingUrl={review.newbuildingUrl}
                  avatarUrl={review.user.avatarUrl}
                  name={review.user.name}
                  date={review.date}
                  rating={review.rating}
                />
              }
              comment={<ReviewComment isLegacy={review.isLegacy} comment={review.comment} />}
              link={<Link text="Все отзывы ЖК" url={review.reviewsUrl} />}
              reaction={<ReviewsReactionsContainer reviewId={review.id} reactions={review.like} />}
            />
          ))}
        </div>
      </ReviewsDetails>
    </ModalWindow>
  );
};
